import React, { useState } from "react";
import { CalendarDays, Sparkles, Loader2 } from "lucide-react";
import { Card, Btn, LabeledInput, LabeledSelect } from "../plan/shared";
import { NIGGLES } from "../../lib/studioApi";

const mondayOf = (d = new Date()) => {
  const x = new Date(d);
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return x.toISOString().slice(0, 10);
};

export const StudioGenerator = ({ themes, onWeek, onSingle }) => {
  const [weekStart, setWeekStart] = useState(mondayOf());
  const [focus, setFocus] = useState("");
  const [theme, setTheme] = useState("longevity");
  const [topic, setTopic] = useState("");
  const [busy, setBusy] = useState("");

  const run = async (kind, fn) => {
    setBusy(kind);
    try { await fn(); } finally { setBusy(""); }
  };

  return (
    <div className="grid lg:grid-cols-2 gap-4">
      <Card title="Plan a week" icon={CalendarDays}>
        <p data-testid="studio-autopilot-note" className="text-[#BEFF38] text-xs font-mono uppercase tracking-[0.18em] mb-2">Autopilot on · next week is written every Sat 18:00 · posts go live 07:00</p>
        <p className="text-zinc-400 text-sm mb-4">4 guides · Mon, Wed, Fri, Sun · every week: 1 train-around-injury guide, 1 app how-to showing how it adapts to injuries, 2 health guides — plus a Tuesday "Niggle of the Week" 4-frame story set.</p>
        <div className="grid gap-3">
          <LabeledInput label="Week starting" type="date" value={weekStart} onChange={(e) => setWeekStart(e.target.value)} data-testid="studio-week-start" />
          <LabeledInput label="Weekly focus (optional)" placeholder="e.g. New Year comeback, strength over 40" value={focus} onChange={(e) => setFocus(e.target.value)} data-testid="studio-week-focus" />
          <Btn disabled={!!busy} onClick={() => run("week", () => onWeek({ week_start: weekStart, focus }))} data-testid="studio-generate-week-btn">
            {busy === "week" ? <Loader2 className="w-4 h-4 animate-spin" /> : <CalendarDays className="w-4 h-4" />}
            {busy === "week" ? "Writing 5 posts…" : "Generate week"}
          </Btn>
        </div>
      </Card>
      <Card title="Single post" icon={Sparkles}>
        <p className="text-zinc-400 text-sm mb-4">One-off how-to carousel on any theme. Kept as a spare until you schedule it.</p>
        <div className="grid gap-3">
          <LabeledSelect label="Theme" value={theme} onChange={(e) => setTheme(e.target.value)} data-testid="studio-theme-select">
            {themes.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
          </LabeledSelect>
          {theme === "niggle" ? (
            <LabeledSelect label="Niggle" value={NIGGLES.includes(topic) ? topic : ""} onChange={(e) => setTopic(e.target.value)} data-testid="studio-niggle-select">
              <option value="">This week's rotation</option>
              {NIGGLES.map((n) => <option key={n} value={n}>{n}</option>)}
            </LabeledSelect>
          ) : (
            <LabeledInput label="Topic or angle (optional)" placeholder="e.g. zone 2 cardio, creatine myths" value={topic} onChange={(e) => setTopic(e.target.value)} data-testid="studio-topic-input" />
          )}
          <Btn disabled={!!busy} onClick={() => run("single", () => onSingle({ theme, topic }))} data-testid="studio-generate-single-btn">
            {busy === "single" ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
            {busy === "single" ? "Writing…" : "Generate post"}
          </Btn>
        </div>
      </Card>
    </div>
  );
};
